import { createSlice } from '@reduxjs/toolkit';
import {
  request,
  generateCancelToken,
  cancelRequests as cancelHttpRequests,
  isCancel,
  ejectCancelInterceptor,
} from 'modules/Api/HttpClient';
import { formatDateToSubmit } from 'modules/Utils/Date';

let cancelToken;

const initialState = {
  loading: false,
  error: null,
  data: {
    page: 1,
    perPage: 25,
    date_from: '',
    date_to: '',
    event: '',
    event_type: '',
    ip: '',
    total: 0,
    access_logs: [],
  },
};

const accessLogsSlice = createSlice({
  name: 'accessLogs',
  initialState,
  reducers: {
    cancelRequests: () => {
      cancelToken?.cancel();
      cancelHttpRequests();
    },
    cleanState: () => ({ ...initialState }),
    requestAccessLogs: (state) => {
      state.loading = true;
      state.error = null;
    },
    receiveAccessLogs: (state, action) => {
      state.loading = false;
      state.data.total = action.payload.total_items;
      state.data.access_logs = action.payload.access_logs;
    },
    receiveAccessLogsError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    changeFilters: (state, action) => {
      state.data.page = action.payload.page ? Number(action.payload.page) : 1;
      state.data.date_from = action.payload.date_from || '';
      state.data.date_to = action.payload.date_to || '';
      state.data.event = action.payload.event || '';
      state.data.event_type = action.payload.event_type || '';
      state.data.ip = action.payload.ip || '';
    },
    changePage: (state, action) => {
      state.data.page = action.payload;
    },
    changePerPage: (state, action) => {
      state.data.perPage = action.payload;
      state.data.page = 1;
    },
    clearFilters: (state) => {
      state.data.page = 1;
      state.data.date_from = '';
      state.data.date_to = '';
      state.data.event = '';
      state.data.event_type = '';
      state.data.ip = '';
    },
  },
});

const Actions = accessLogsSlice.actions;

const Selectors = {
  fetchState: (state) => state.accessLogs,
  loading: ({ accessLogs: { loading } }) => ({ loading }),
};

const Async = {
  fetchAccessLogs: () => async (dispatch, getState) => {
    const {
      accessLogs: {
        data: { page, perPage, date_from, date_to, event, event_type, ip },
      },
    } = getState();

    ejectCancelInterceptor();
    cancelToken?.cancel();
    cancelToken = generateCancelToken();

    dispatch(Actions.requestAccessLogs());

    let action;

    try {
      const response = await request({
        cancelToken: cancelToken.token,
        method: 'GET',
        url: '/cms/v1/access_logs',
        params: {
          page,
          per_page: perPage,
          date_from: formatDateToSubmit(date_from),
          date_to: formatDateToSubmit(date_to),
          event: event || undefined,
          event_type: event_type || undefined,
          ip: ip || undefined,
        },
      });

      action = Actions.receiveAccessLogs(response.data.content);
    } catch (e) {
      if (!isCancel(e)) {
        action = Actions.receiveAccessLogsError(e.message);
      }
    }

    action && dispatch(action);
  },
};

const { reducer } = accessLogsSlice;

export { reducer, Actions, Async, Selectors };
